import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";
import { EffectCards } from "swiper";
import { EffectCreative } from "swiper";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import "swiper/css/effect-cards";
import "swiper/css/effect-creative";
import "swiper/css/pagination";
import "swiper/css/navigation";


import { LazyLoadImage } from 'react-lazy-load-image-component';

function Artwork() {


    return (
        <div>
        <div className="superDrip previews slideshow text-center" style={{marginTop: "5em"}}>
        <h2>superDRIP</h2>
          <Swiper
          spaceBetween={10}
          slidesPerView={"auto"}
          modules={[EffectCreative, Pagination]}
          pagination={{
            dynamicBullets: true,
          }}
          creativeEffect={{
            prev: {
              shadow: true,
              translate: [0, 0, -400],
            },
            next: {
              translate: ["100%", 0, 0],
            },
          }}
        >
          <SwiperSlide>
            <div className="superDRIP" >
            <LazyLoadImage
            alt="superDRIP"
            src="/superDRIP_1.png" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="superDRIP"  >
            <LazyLoadImage
            alt="superDRIP"
            src="/superDRIP_5.jpg" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="superDRIP"  >
              <LazyLoadImage
            alt="superDRIP"
            src="/superDRIP_2.png" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="superDRIP"  >
            <LazyLoadImage
            alt="superDRIP"
            src="/superDRIP_3.png" />

            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="superDRIP"  >
            <LazyLoadImage
            alt="superDRIP"
            src="/superDRIP_4.jpg" />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className="slideshow slideshow-box">
      <h2 className="text-center">@URS pieces</h2>
      <Swiper
          spaceBetween={10}
          slidesPerView={"auto"}
          modules={[EffectCreative, Pagination]}
          grabCursor={true}
          pagination={{
            dynamicBullets: true,
          }}
          creativeEffect={{
            prev: {
              shadow: true,
              translate: [0, 0, -400],
            },
            next: {
              translate: ["100%", 0, 0],
            },
          }}
        >
          <SwiperSlide className="autoWidth">
            <div className="urs"  >
              <img src="/URS_1.webp" />
            </div>
          </SwiperSlide>
          <SwiperSlide className="autoWidth">
            <div className="urs"   >
              <img src="/URS_2.png" />
            </div>
          </SwiperSlide>
          <SwiperSlide className="autoWidth">
            <div className="urs"   >
              <img src="/URS_5.png" />
            </div>
          </SwiperSlide>
          <SwiperSlide className="autoWidth">
            <div className="urs"   >
              <img src="/URS_3.webp" />
            </div>
          </SwiperSlide>
          <SwiperSlide className="autoWidth">
            <div className="urs"   >
              <img src="/URS_6.png" />
            </div>
          </SwiperSlide>
          <SwiperSlide className="autoWidth">
            <div className="urs"  >
              <img src="/URS_4.png" />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      </div>
    )
}


export default Artwork